import axios from 'axios'

export default {
    namespaced: true,
    state: {
        enrolmentRegistrations: [],
    },
    mutations: {
        SET_ENROLMENT_REGISTRATIONS(state, payload) {
            state.enrolmentRegistrations = payload;
        },
    },
    actions: {
        FetchEnrolmentRegistration({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/enrolment-registrations/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchEnrolmentRegistration: ${error.message}`));
            });
        },
        FetchLatestCompletedEnrolmentRegistration({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/enrolment-registrations/fetch/latest/completed`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchLatestCompletedEnrolmentRegistration: ${error.message}`));
            });
        },
        FetchEnrolmentRegistrations({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/enrolment-registrations/fetch/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_ENROLMENT_REGISTRATIONS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchEnrolmentRegistrations: ${error.message}`));
            });
        },
        InsertEnrolmentRegistration({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/enrolment-registrations/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => { reject(error.message); });
            });
        },
        UpdateEnrolmentRegistration({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/enrolment-registrations/update`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => { reject(error.message); });
            });
        },
        UpdateEnrolmentRegistrationLastAccessed({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/enrolment-registrations/update/last-accessed`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => { reject(error.message); });
            });
        },
    },
    getters: {
        EnrolmentRegistrations(state) { return state.enrolmentRegistrations; },
    }
}
